import { SelectOptionProps } from '@acceso/design-system';
import { useMemo } from 'react';

import { useCurrentLanguage } from '@/utils/i18n.utils';

import { useGetProgramsClassifications } from '../api/get-programs-classifications';

export function useProgramClassificationOptions(): SelectOptionProps<string>[] {
  const currentLanguage = useCurrentLanguage();
  const { data: classifications = [] } = useGetProgramsClassifications();
  const classificationsOptions = useMemo(
    () =>
      classifications.map(classification => ({
        label: classification.labels[currentLanguage],
        value: classification.value,
      })),
    [classifications]
  );

  return classificationsOptions;
}
